import "./plugins/validation";
import "./registerServiceWorker";
import "./sass/global.scss";
import * as VueGoogleMaps from "vue2-google-maps";
import App from "./App";
import Can from "./plugins/can";
import Echo from "./plugins/echo";
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueAuth from "@websanova/vue-auth";
import VueAxios from "./plugins/axios";
import VueMeta from "vue-meta";
import VuePellEditor from "vue-pell-editor";
import VueWait from "vue-wait";
import authAuthDriver from "./auth/drivers/auth";
import authHttpDriver from "./auth/drivers/http";
import authRouterDriver from "./auth/drivers/router";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Model } from "vue-api-query";

if ( process.env.VUE_APP_SOCKET_URL ) {
	if ( !( window as any ).io ) {
		( window as any ).io = require( "socket.io-client" );
	}

	Vue.use( Echo, {
		broadcaster: "socket.io",
		host: process.env.VUE_APP_SOCKET_URL
	} );
}

Vue.use( VueGoogleMaps, {
	load: {
		key: "AIzaSyDqDc2wkmkAoLfDXWnobCwyY5u6D_ut65k",
		libraries: [ "geometry", "places" ]
	}
} );

Vue.use( VueMeta );

Vue.use( VuePellEditor );

Vue.use( VueAxios );

Vue.use( VueAnalytics, {
	autoTracking: {
		exception: true,
		exceptionLogs: process.env.NODE_ENV === "development",
		screenview: true,
		pageviewOnLoad: false
	},
	checkDuplicatedScript: true,
	debug: {
		sendHitTask: process.env.NODE_ENV === "production",
		trace: process.env.NODE_ENV === "development"
	},
	id: "UA-1329447-8",
	router
} );

Vue.use( VueAuth, {
	auth: authAuthDriver,
	http: authHttpDriver,
	rolesVar: "permissions",
	router: authRouterDriver,
	rememberMe: true,
	refreshData: {
		method: "GET",
		interval: 50
	},
	parseUserData( data ) {
		return data;
	}
} );

Vue.use( Can );

Vue.use( VueWait );

Vue.config.productionTip = false;

const app = new Vue( {
	auth: VueAuth,
	render: h => h( App ),
	router,
	store,
	vuetify,
	wait: new VueWait( { registerComponent: false } )
} ).$mount( "#app" );

Model.$http = app.axios;
Model.app = app;

export default app;
